import camelize from 'camelcase-keys-deep';

export default class QuestionOption {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }
}
